import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Grift, Arial, sans-serif',
  },
});

export default theme;